<template>
  <div>
    <form @submit="createCategory($event)">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label for="category"
              >Category Name
              <span
                class="invalid"
                v-if="veeErrors.first('category') && !categoryForm.name.value"
              >
                - Field is required
              </span>
            </label>
            <input
              name="category"
              type="text"
              v-model.trim="categoryForm.name.value"
              placeholder="Enter category name"
              class="form-control"
              v-validate="'required|max:100'"
              data-vv-as="category name"
            />
            <div
              v-if="veeErrors.first('category') && categoryForm.name.value"
              class="invalid-feedback"
            >
              {{ veeErrors.first("category") }}
            </div>
          </div>
          <div class="form-group">
            <label for="status"
              >Status
              <span class="invalid" v-if="categoryForm.status.value === ''">
                - Field is required
              </span>
            </label>
            <CustomSelect
              :options="status"
              :placeholder="'Select a Status'"
              v-model="categoryForm.status"
              :searchable="false"
              form_type="form_type"
            />
          </div>
          <div class="form-group">
            <label for="type"
              >Category Type
              <span class="invalid" v-if="categoryForm.type.value === ''">
                - Field is required
              </span>
            </label>
            <CustomSelect
              :options="type"
              :placeholder="'Select a Category Type'"
              v-model="categoryForm.type"
              :searchable="false"
              form_type="form_type"
            />
          </div>
          <div class="form-group">
            <label for="description">Description </label>
            <textarea
              class="form-control form-control-sm"
              name="description"
              v-model="categoryForm.description.value"
              placeholder="Set Description (Optional)"
            >
            </textarea>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <ActionButton
            :theme="{ primary, secondary, event, danger }"
            type="submit"
            label="Save"
            style="width: auto; margin-left: auto;"
            :disabled="loader"
          />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "@/helpers/axios";
import ActionButton from "@/components/ActionButton";
import _ from "lodash";
import types from "@/variables/types.json";
import { socketSender } from "@/helpers/socket";

const CustomSelect = () => import("@/components/Select");

export default {
  name: "AddCategory",
  components: {
    ActionButton,
    CustomSelect
  },
  props: {
    singleRecord: {
      type: Object,
      default: () => {}
    },
    link: {
      type: String,
      default: null
    }
  },
  data: () => ({
    editCategoryId: null,
    showMediaGallery: false,
    status: types.status,
    type: types.categoryType,
    categoryForm: {
      name: {
        value: null,
        attributes: [{ required: true }]
      },
      description: {
        value: null,
        attributes: [{ required: false }]
      },
      status: {
        label: null,
        value: null,
        attributes: [{ required: true }]
      },
      type: {
        label: null,
        value: null,
        attributes: [{ required: true }]
      }
    },
    url: null,
    fileName: null,
    apiOptions: {
      mode: "pagination",
      link: null
    },
    loader: false
  }),
  created() {
    this.editSelectedCategory();
  },
  methods: {
    handleShowMedia() {
      this.showMediaGallery = true;
    },
    handleCloseGallery() {
      this.showMediaGallery = false;
    },
    editSelectedCategory() {
      if (this.singleRecord) {
        let singleRecord = this.singleRecord;
        let form = this.categoryForm;

        this.editCategoryId = singleRecord._id;
        Object.keys(form).map(el => {
          if (el == "status" || el == "type") {
            let data = _.filter(this[el], col => {
              return col.value == singleRecord[el];
            })[0];
            form[el].value = data.value;
            form[el].label = data.label;
          } else {
            form[el].value = singleRecord[el];
          }
        });
      }
    },
    fetchStatus(params) {
      let { search } = params;
      this.status = types.status.filter(item =>
        item.label.toLowerCase().includes(search.toLowerCase())
      );
    },
    async createCategory(event) {
      this.loader = true;
      event.preventDefault();
      let formIsValid = true;
      let form = this.categoryForm;

      Object.keys(form).map(key => {
        let required = _.filter(form[key].attributes, o => {
          return o.required == true;
        });
        if (
          required.length != 0 &&
          (form[key].value == null || form[key].value < 0)
        ) {
          if ((key == "status" || key == "type") && form[key].value < 0) {
            form[key].value = "";
            return (formIsValid = false);
          } else {
            form[key].value = "";
            return (formIsValid = false);
          }
        }
      });
      try {
        if (formIsValid == false) {
          throw {
            type: "warning",
            title: "Warning",
            error: new Error("Please fill the required fields")
          };
        }
        if (form.name.value.length > 100) {
          throw {
            type: "error",
            title: "Warning",
            error: new Error(
              "You have reached the maximum limit of characters allowed"
            )
          };
        }
        let formSave = {};
        Object.keys(form).map(el => {
          formSave[el] =
            form[el].value && form[el].value.label
              ? form[el].value.value
              : form[el].value;
        });
        if (this.editCategoryId) {
          await axios.patch("/categories/" + this.editCategoryId, formSave);
        } else {
          /**
           * SOCKET: Add Category
           */
          await socketSender(
            "updateLog",
            `${this.$store.getters.getFullUser} added a new Category named ${formSave.name}`
          );
          await axios.post("/categories", formSave);
        }

        await this.$store.dispatch("FETCH_COLLECTION_PER_PAGE", this.link);

        await this.$toastr.success("Your changes are saved", "Success");
        this.$emit("close");
        this.loader = false;
      } catch (error) {
        const errType = error.type || "error";
        const errTitle = error.title || "Error";
        const errMsg = error.error.message || error.message;

        this.$toastr[errType](errMsg, errTitle);
      } finally {
        this.loader = false;
      }
    }
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  }
};
</script>

<style lang="scss">
.form-group {
  .invalid {
    color: red;
  }
  .password-wrapper {
    position: relative;
    img {
      cursor: pointer;
      height: auto;
      position: absolute;
      right: 0.75em;
      top: 11px;
      transition: all 0.2s ease;
      &:hover,
      &.is-visible {
        filter: brightness(50%);
      }
    }
  }
  .input-wrapper {
    button {
      margin-left: 15px;
    }
  }
  label {
    font-family: "Gotham", sans-serif;
    font-size: $font-size-xs;
    font-weight: 500;
  }
  textarea {
    color: $gray-800;
    height: 80px;
    font-size: $font-size-xs;
    font-family: "Gotham Book", sans-serif;
    resize: none;
  }
  input {
    border-radius: 5px;
    color: $gray-800;
    font-family: "Gotham Book", sans-serif;
    font-size: $font-size-xs;
  }
  ul {
    font-size: $font-size-xs;
  }
  img {
    display: block;
    height: 200px;
    max-width: 100%;
    object-fit: cover;
  }
  .upload-zone {
    align-items: center;
    cursor: pointer;
    display: flex;
    font-family: "Gotham Book";
    font-size: $font-size-xs;
    padding: 30px;
    height: 200px;
    width: 100%;
    &.file-zone {
      background-color: $brand-secondary;
      border: 1px dashed $brand-primary;
      color: $brand-primary;
    }
    &.featured-zone {
      background-color: $gray-200;
      color: $gray-550;
    }
  }
}

.switch {
  background-color: $gray-300;
  cursor: pointer;
  border-radius: 10px;
  height: 20px;
  overflow: hidden;
  padding: 5px;
  position: relative;
  width: 35px;
  .indicator {
    animation: bounce-to-left 0.3s ease-in-out forwards;
    background-color: $white;
    border-radius: 50%;
    height: 14px;
    position: absolute;
    width: 14px;
    top: 3px;
    transition: all 0.2s ease-in;
    &.active {
      right: 0;
    }
  }
  &::before {
    border-radius: 10px;
    content: "";
    height: 100%;
    left: 0;
    position: absolute;
    transform: scale(0);
    transition: all 0.3s ease-in-out;
    top: 0;
    width: 100%;
  }
  &.active {
    &::before {
      background-color: var(--primary, $brand-primary);
      transform: scale(1);
    }
    .indicator {
      animation: bounce-to-right 0.3s ease-in-out forwards;
    }
  }
  &.disabled {
    &::before {
      background-color: $gray-300 !important;
    }
  }
}

.submit-row {
  span {
    color: $gray-900;
    cursor: pointer;
    font-family: "Gotham Book";
    font-size: $font-size-xs;
    margin-left: 14px;
  }
}

@keyframes bounce-to-right {
  0% {
    left: 5px;
  }
  50% {
    left: 18px;
  }
  100% {
    left: 16px;
  }
}

@keyframes bounce-to-left {
  0% {
    left: 16px;
  }
  50% {
    left: 3px;
  }
  100% {
    left: 5px;
  }
}
</style>
